import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=168cf606&scoped=true&"
import script from "./LayoutHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=168cf606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168cf606",
  null
  
)

export default component.exports